<app-button-group>
    <app-button
        buttonType="flat-highlight"
        (buttonClick)="goToDemo()"
        data-qa="landing-page_demo-button"
        ><translate>Request a demo</translate></app-button
    >
    <app-button
        buttonType="stroked-inverted"
        (buttonClick)="goToRegister()"
        data-qa="landing-page_register-button"
        ><translate>Register now</translate></app-button
    >
</app-button-group>
